<template>
  <img v-if="thumbnailUrl" :src="thumbnailUrl" class="mb-2 aspect-video h-3 w-3" />
  <DButton fluid @click="changeAsset($event)" :disabled="disabled"> Select Asset </DButton>
</template>

<script setup>
import { defineAsyncComponent, ref, watch } from 'vue';

import { DButton, useDialog } from '@disguise/cloud-ui';

import { useAssetStore } from '@/stores/api/asset';
const assetStore = useAssetStore();

const DriveSelector = defineAsyncComponent(() => import('@/components/dialogs/DriveSelector.vue'));
const LibrarySelector = defineAsyncComponent(() => import('@/components/dialogs/LibrarySelector.vue'));

const emit = defineEmits(['update:modelValue']);

const dialog = useDialog();

const props = defineProps({
  modelValue: {
    type: [String, null],
    default: null,
  },
  type: {
    type: String,
    default: 'asset',
  },
  filter: {
    type: String,
    default: 'media',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const thumbnailUrl = ref(null);

watch(
  () => props.modelValue,
  async (newVal) => {
    if (props.type === 'asset') {
      const asset = await assetStore.fetch(props.modelValue);

      if (asset && asset.latest_version) {
        thumbnailUrl.value = asset.latest_version.thumbnail ?? asset.latest_version.file;
      } else {
        thumbnailUrl.value = null;
      }
    }
    // load asset and get file
  },
  { immediate: true }
);

const changeAsset = (field) => {
  if (props.type === 'projector' || props.type === 'led') {
    openLibrarySelector();
  } else {
    openDriveSelector();
  }
};

const openDriveSelector = () => {
  dialog.open(DriveSelector, {
    data: {
      filter: props.filter,
    },
    props: {
      header: 'Asset List',
      style: {
        width: '50vw',
      },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
      modal: true,
    },
    onClose: (options) => {
      if (options.data?.buttonType !== 'Cancel') {
        if (options.data?.code) {
          emit('update:modelValue', options.data.code);
        }
      }
    },
  });
};

const openLibrarySelector = () => {
  dialog.open(LibrarySelector, {
    data: {
      filter: props.type,
      mode: 'swap',
    },
    props: {
      header: props.type == 'projector' ? 'Projector List' : 'LED List',
      style: {
        width: '50vw',
      },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
      modal: true,
    },
    onClose: (options) => {
      if (options.data?.buttonType !== 'Cancel') {
        if (options.data?.code) {
          emit('update:modelValue', options.data.code);
        }
      }
    },
  });
};
</script>
